export class GetCMSTextData {
  static readonly type = "[CmsData] Get CMS text data";
}
